import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

// Notifications
export function* getNotificationReminders(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.NOTIFICATIONS.GET_NOTIFICATION_REMINDERS, action.payload, true);
}

export function* insertUpdateNotificationReminders(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.NOTIFICATIONS.INSERT_UPDATE_NOTIFICATION_REMINDERS, action.payload, true);
}